import React, { useEffect, useState } from 'react'
import { Link as Scroll } from 'react-scroll'

const NAV_ITEMS = ['About', 'Rooms', 'Service', 'Schedule', 'Access', 'News', 'Contact']

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 80)
        }

        handleScroll()
        window.addEventListener('scroll', handleScroll, { passive: true })

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <header className={isScrolled ? 'is-scrolled' : ''}>
            <Scroll className='wordmark' to='top' smooth={true} duration={1000}>
                Liina Dance Studio
            </Scroll>
            <nav>
                {NAV_ITEMS.map((item) => (
                    <Scroll key={item} to={item.toLowerCase()} smooth={true} duration={1000}>
                        {item}
                    </Scroll>
                ))}
            </nav>
        </header>
    )
}

export default Header
